"use client";
import { Box, Typography, Button } from "@mui/material";
import Link from "next/link";
export default function NotFound() {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      height="100vh"
      textAlign="center"
      marginTop={10}
    >
      <Typography
        marginBottom={10}
        variant="h2"
        fontWeight="bold"
        color="error"
      >
        404
      </Typography>
      <Typography marginBottom={10} variant="h4">
        Page Not Found
      </Typography>
      <Button
        variant="contained"
        component={Link}
        href="/search"
        color="primary"
      >
        Back to Search
      </Button>
    </Box>
  );
}
